import { createFileRoute } from '@tanstack/react-router';
import MetadataSortingAndFilteringComponent from 'src/Administration/Metadata/MetadataSortingAndFiltering/MetadataSortingAndFiltering';

export const Route = createFileRoute('/systemadmin/_layout/metadata/sorting-and-filtering')({
  component: MetadataSortingAndFilteringComponent,
});
